import { render } from "./NedbankDepositResponse.vue?vue&type=template&id=63d29f84&scoped=true"
import script from "./NedbankDepositResponse.vue?vue&type=script&lang=js"
export * from "./NedbankDepositResponse.vue?vue&type=script&lang=js"

import "./NedbankDepositResponse.vue?vue&type=style&index=0&id=63d29f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d29f84"]])

export default __exports__